import styled from 'styled-components';

const NameWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* @media screen and (max-width: 430px), screen and (min-height: 600px) {
   
  } */
`;

export default NameWrapper;
